var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.name)+"\n    ")]),_c('br'),_c('div',{staticClass:"body-2"},[_vm._v("\n        "+_vm._s(_vm.vicinity)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }